export default __webpack_public_path__ + "images/icons/share/twitter-share-button-00c2d7e019b481cf6da5ebda6d0d385e.svg";